import React, { useEffect, useState } from 'react'
import Image, { StaticImageData } from 'next/image'

type Props = {
  countDown: number
  background: StaticImageData
  backgroundWidth?: string
  text?: StaticImageData
  rightBackgroundColor?: string
  darkTheme?: boolean
  decorations?: React.ReactNode
  textDecorations?: React.ReactNode
  textHeight?: string
  textWidth?: string
  textPosition?: string
  timerBackgroundColor?: string
  timerborderStyle?: string
  timerTextColor?: string
}
function Time(
  num: number,
  borderStyle = '',
  timerBackgroundColor = 'bg-white',
  timerTextColor = 'text-black',
) {
  return (
    <div
      className={`rounded-lg ${borderStyle} ${timerBackgroundColor} ${timerTextColor} text-lg-bold p-1 shrink-0 w-10 flex flex-row items-center justify-center font-oswald text-nowrap`}
    >
      {num < 10 ? `0${num}` : `${num}`}
    </div>
  )
}
export default function HolidayBanner({
  countDown,
  background,
  backgroundWidth = ' w-1/2 ',
  text,
  darkTheme,
  rightBackgroundColor = 'bg-gnar-500',
  decorations,
  textDecorations,
  textWidth = ' md:w-[300.21px] w-full',
  textHeight = ' h-[30.77px]',
  textPosition = '  ',
  timerTextColor = 'text-black',
  timerBackgroundColor = 'bg-white',
  timerborderStyle,
}: Props) {
  const [timeLeft, setTimeLeft] = useState(countDown) // Initial seconds

  useEffect(() => {
    if (countDown) {
      setTimeLeft(countDown)
    }
  }, [countDown])

  useEffect(() => {
    // Update the countdown every second
    const interval = setInterval(() => {
      setTimeLeft((prevTime) => (prevTime > 0 ? prevTime - 1 : 0))
    }, 1000)

    // Clear interval on component unmount
    return () => clearInterval(interval)
  }, [])

  return (
    <div
      className={'relative w-full border-b border-t border-fizz-600 h-16 overflow-hidden'}
      style={{
        backgroundColor: rightBackgroundColor,
      }}
    >
      <div className={`relative ${backgroundWidth} py-5 h-16`}>
        <Image
          src={background}
          alt={'BackGround'}
          className={'hidden md:flex'}
          fill={true}
        />

        {decorations}
      </div>

      <div
        className={
          'flex flex-row items-center container justify-between absolute top-0 bottom-0 left-1/2 -translate-x-1/2'
        }
      >
        {text && (
          <div
            className={`relative ${textWidth} ${textHeight} ${textPosition}`}
          >
            <Image
              src={text}
              alt={'text'}
              className={'object-contain md:flex'}
              fill={true}
            />

            {textDecorations}
          </div>
        )}

        <div
          className={
            'flex-row justify-end px-5 left-1/2 -translate-x-1/2 absolute md:right-0 md:translate-x-0 hidden md:flex mt-0.5'
          }
        >
          <div className={'flex flex-row gap-1 items-center'}>
            <div
              className={`${
                darkTheme ? ' text-white' : 'text-fizz-1000'
              }  md:font-oswald text-lg-normal`}
            >
              REMAINING:
            </div>
            <div
              className={`flex flex-row gap-1 font-oswald text-lg-normal ${
                darkTheme ? ' text-white' : 'text-fizz-1000'
              } items-center md:ml-4`}
            >
              <div className={'flex flex-col items-center gap-0'}>
                {Time(
                  Math.floor(timeLeft / (24 * 3600)),
                  timerborderStyle,
                  timerBackgroundColor,
                  timerTextColor,
                )}
                <div className={`text-xs-normal font-oswald ${darkTheme ? 'text-white' : 'text-fizz-1000'}`}>
                  DAYS
                </div>
              </div>
              <div className={'mb-5'}>:</div>
              <div className={'flex flex-col items-center gap-0'}>
                {Time(
                  Math.floor((timeLeft % (24 * 3600)) / 3600),
                  timerborderStyle,
                  timerBackgroundColor,
                  timerTextColor,
                )}
                <div className={`text-xs-normal font-oswald  ${darkTheme ? 'text-white' : 'text-fizz-1000'}`}>
                  HOURS
                </div>
              </div>
              <div className={'mb-5'}>:</div>
              <div className={'flex flex-col items-center gap-0'}>
                {Time(
                  Math.floor((timeLeft % 3600) / 60),
                  timerborderStyle,
                  timerBackgroundColor,
                  timerTextColor,
                )}
                <div className={`text-xs-normal font-oswald  ${darkTheme ? 'text-white' : 'text-fizz-1000'}`}>
                  MINUTES
                </div>
              </div>
              <div className={'mb-5'}>:</div>
              <div className={'flex flex-col items-center gap-0'}>
                {Time(
                  Math.floor(timeLeft % 60),
                  timerborderStyle,
                  timerBackgroundColor,
                  timerTextColor,
                )}
                <div className={`text-xs-normal font-oswald  ${darkTheme ? 'text-white' : 'text-fizz-1000'}`}>
                  SECONDS
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
